module.exports = __webpack_public_path__ + "static/media/add.831341d7.svg";